<template>
  <b-nav-item-dropdown
    right
    no-caret
    class="account-dropdown"
  >
    <template slot="button-content">
      <div class="account-button">
        <div class="user-avatar">
          {{ userInitials }}
        </div>
      </div>
    </template>

    <!-- Current User Info -->
    <div v-if="userInfo && userInfo.name" class="current-user-info">
      <div class="user-name-display">
        <i class="fa fa-user me-1"></i>
        <div class="user-details">
          <div class="user-name">
            <strong>{{ userInfo.name }}</strong>
            <span v-if="userInfo.surname">{{ userInfo.surname }}</span>
          </div>
          <div v-if="userInfo.role || userInfo.user_role" class="user-role">
            {{ userInfo.role || userInfo.user_role }}
          </div>
        </div>
      </div>
      <b-dropdown-divider />
    </div>

    <b-dropdown-item @click="navigateToApi()">
      <i class="fa fa-code" /> API
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item @click="logout()">
      <i class="fa fa-lock" /> Cerrar sesión
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
// import { user } from '@/services/api/ExpertoRetail'
import webSocketService from '@/services/WebSocketService'
import useAuthentication from '@/app/authentication/compositions/UseAuthentication'

export default {
  name: 'HeaderUserInfo',
  setup () {
    const { logout: authLogout } = useAuthentication()

    return {
      authLogout
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo || {}
    },
    userInitials () {
      if (!this.userInfo || !this.userInfo.name) return 'U'

      const names = this.userInfo.name.trim().split(' ')
      if (names.length === 1) {
        return names[0].charAt(0).toUpperCase()
      }

      // Take first letter of first name and first letter of last name
      return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase()
    }
  },
  methods: {
    navigateToApi () {
      this.$router.push({ name: 'UserApiIndex' })
    },
    async logout () {
      // Disconnect WebSocket before logout
      webSocketService.disconnect()

      // Use new composition API logout (calls backend + clears localStorage and WebSocket)
      await this.authLogout()

      // Clear other app state (keep existing store mutations for other modules)
      this.$store.commit('reset_app')

      // Only commit filter reset if the mutation exists (it's namespaced)
      try {
        this.$store.commit('filterRequestObject/commit_filterPane_resetState')
      } catch (error) {
        console.warn('⚠️ Filter pane reset mutation not found:', error.message)
      }

      // Navigate to login
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
/* Account dropdown styling */
.account-dropdown ::v-deep .dropdown-menu {
  min-width: 200px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0;
  margin-top: 0.5rem;
}

.account-dropdown ::v-deep .dropdown-item {
  padding: 0.75rem 1rem;
  border-radius: 0;
  transition: all 0.2s ease;
  color: #495057;
  font-weight: 500;
}

.account-dropdown ::v-deep .dropdown-item:hover {
  background-color: #f8f9fa;
  color: #212529;
}

.account-dropdown ::v-deep .dropdown-item:last-child {
  border-radius: 0 0 8px 8px;
}

.account-button {
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.user-avatar:hover {
  transform: scale(1.05);
}

/* Mobile responsiveness */
@media (max-width: 767px) {
  .user-avatar {
    width: 24px;
    height: 24px;
    font-size: 0.75rem;
  }
}

/* Current user info styling */
.current-user-info {
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px 8px 0 0;
  margin: 0;
  border-bottom: 1px solid #dee2e6;
}

.user-name-display {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.user-name-display .fa-user {
  color: #667eea;
  font-size: 1.1rem;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.user-name {
  color: #495057;
  font-size: 0.9rem;
  line-height: 1.3;
  font-weight: 500;
}

.user-name strong {
  color: #212529;
  font-weight: 600;
  margin-right: 0.25rem;
}

.user-role {
  color: #6c757d;
  font-size: 0.8rem;
  font-style: italic;
  opacity: 0.85;
}

.current-user-info + .dropdown-divider {
  margin: 0;
  border-color: #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/app/nav_bar/HeaderDropdownAccntCustom.vue